import { t } from "i18next";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { getKeyFromText } from "../../../utils/Utilities";
export const addSubOwnerStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  minWidth: "350px !important",

  background: "color.white",
  boxShadow:
    "  0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
  padding: "0px 0 10px 0",
  display: "flex",
  flexDirection: "column",
};

export const addSubOwnersInitialValues = {
  quantity: "",
  name: "",
  ownership: "",
  value: "",
  weight: "",
};

export const insuranceSubOwnerInitialValues = {
  name: "",
  insuredPerson: "",
  beneficiary: "",
  value: "",
  deathBenifit: "",
};

export const addSubOwnersValidationSchemaSH = (t) => {
  return Yup.object().shape({
    companyName: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    nameOfOwner: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    value: Yup.number()
      .min(0, t("must-be-positive"))
      .max(9999999999, t("max-10-digits")),
    ownerShipPercentage: Yup.number()
      .required(t("required"))
      .min(0, t("between-0-100"))
      .max(100, t("between-0-100")),
    information: Yup.string().max(150, "Max 150 characters are allowed!!"),
  });
};
export const addSubOwnersValidationSchemaLoans = (t) => {
  return Yup.object().shape({
    borrower: Yup.string()
      .min(0, t("must-be-positive"))
      .max(50, t("max-50-characters")),
    currentStatus: Yup.string()
      .matches(/^\d*\.?\d*$/, t("you-must-enter-a-number"))
      .min(0, t("must-be-positive"))
      .max(15, t("max-15-characters")),
    interestRate: Yup.number()
      .typeError("you-must-enter-a-number")
      .min(0, t("between-0-100"))
      .max(100, t("between-0-100")),
    // fixedInterestRate: Yup.number()
    //   .typeError("you-must-enter-a-number")
    //   .min(0, t("between-0-100"))
    //   .max(100, t("between-0-100")),

    // fixedInterestRate: Yup.string(),
    fixedInterestRate: Yup.string()
      .required(t("required"))
      .nullable()
      .test("DATE", t("choose-between-1930"), (value) => {
        if (value) {
          let [yyyy, mm, dd] = value?.split("-");
          let currentDate = new Date(Date.now()).toLocaleDateString("en-GB");
          let [curDay, curMonth, curYear] = currentDate.split("/");
          return 1930 <= yyyy && curYear >= yyyy;
        }
      }),
    // .required(t("required")),
    // .test("DATE", t("between-1950-2050"), (value) => {
    //   if (value) {
    //     let [yyyy, mm, dd] = value?.split("-");
    //     return 1950 <= yyyy && yyyy <= 2050;
    //   }
    // })
    // .nullable(),

    forWhat: Yup.string().max(150, "max-150-characters"),
    creditInstitution: Yup.string().max(150, "max-150-characters"),
    accountNumber: Yup.string().max(150, "max-150-characters"),
  });
};
export const addSubOwnersValidationSchemaDonations = (t) => {
  return Yup.object({
    donatedThings: Yup.string().max(50, t("max-50-characters")),
    //.matches(/^[A-Za-z0-9 ]+$/, t("only-char-numbers")),
    donationValue: Yup.number().min(0, t("must-be-positive")),
    donationFrom: Yup.string().max(50, t("max-50-characters")),
    dateOfValue: Yup.string(),
  });
};

export const addSubOwnersValidationSchemaCOSH = (t) => {
  return Yup.object().shape({
    companyName: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    nameOfOwner: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    ownerShipPercentage: Yup.number()
      .required(t("required"))
      .min(0, t("between-0-100"))
      .max(100, t("between-0-100")),
    value: Yup.number()
      .min(0, t("must-be-positive"))
      .max(9999999999, t("max-10-digits")),
    information: Yup.string().max(150, t("max-150-characters")),
  });
};
export const addSubOwnersValidationSchemaSS = (t) => {
  return Yup.object().shape({
    type: Yup.object().required(t("required")),
    nameOfOwner: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    ownerShipPercentage: Yup.number()
      .required(t("required"))
      .min(0, t("between-0-100"))
      .max(100, t("between-0-100")),
    quantity: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    value: Yup.number()
      .required(t("required"))
      .min(0, t("must-be-positive"))
      .max(9999999999, t("max-10-digits")),
    information: Yup.string().max(150, t("max-150-characters")),
  });
};

export const types = () => {
  const { t } = useTranslation();
  return [
    { name: t("rs-input-resident-3"), id: 1 },
    { name: t("rs-input-resident-1"), id: 2 },
    { name: t("rs-input-resident-2"), id: 3 },
  ];
};

export const goldRawMaterialFields = (t) => {
  return [
    {
      label: t("common-table-heading-11"),
      name: "designation",
      placeholder: t("common-table-heading-11"),
      type: "text",
    },
    {
      label: t("common-table-heading-6"),
      name: "name",
      placeholder: t("placeholder-1"),
      type: "text",
    },
    {
      label: t("common-table-heading-2"),
      name: "ownership",
      placeholder: "00",
      type: "number",
    },
    {
      label: t("rm-table-heading-2"),
      name: "weight",
      placeholder: "",
      type: "format-number",
    },
    {
      label: t("soi-heading-4"),
      name: "value",
      placeholder: "00 € ",
      type: "format-number",
    },
  ];
};

export const goldRawMaterialFieldsValidationSchema = (t) => {
  return Yup.object({
    designation: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    name: Yup.string().required(t("required")).max(50, t("max-50-characters")),
    ownership: Yup.number()
      .required(t("required"))
      .min(0, t("between-0-100"))
      .max(100, t("between-0-100")),
    weight: Yup.number().required(t("required")).min(0, t("must-be-positive")),
    value: Yup.number()
      .required(t("required"))
      .max(9999999999, t("max-10-digits"))
      .min(0, t("must-be-positive")),
  });
};

export const insuranceFields = (t) => {
  return [
    {
      label: t("i-table-heading-2"),
      name: "name",
      placeholder: t("placeholder-1"),
      type: "text",
    },
    {
      label: t("i-table-heading-3"),
      name: "insuredPerson",
      placeholder: t("placeholder-1"),
      type: "text",
    },
    {
      label: t("i-table-heading-4"),
      name: "beneficiary",
      placeholder: t("placeholder-1"),
      type: "text",
    },
    {
      label: t("i-table-heading-5"),
      name: "value",
      placeholder: "000 € ",
      type: "format-number",
    },
    {
      label: t("i-table-heading-6"),
      name: "deathBenifit",
      placeholder: "000 € ",
      type: "format-number",
    },
  ];
};
export const insuranceFieldsValidationSchema = (t) => {
  return Yup.object({
    name: Yup.string().required(t("required")),
    beneficiary: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    insuredPerson: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    value: Yup.number()
      .required(t("required"))
      .max(9999999999, t("max-10-digits"))
      .min(0, t("must-be-positive")),
    deathBenifit: Yup.number()
      .required(t("required"))
      .max(9999999999, t("max-10-digits"))
      .min(0, t("must-be-positive")),
  });
};
export const addLoansInitialValues = {
  currentState: "",
  borrower: "",
  interestRate: "",
  fixedInterestRate: "",
  forWhat: "",
  creditInstitution: "",
  accountNumber: "",
};

export const loans = (t) => {
  return [
    {
      label: t(getKeyFromText("Current status")),
      name: "currentStatus",
      placeholder: "€",
      type: "format-number",
    },
    {
      label: t(getKeyFromText("Borrower")),
      name: "borrower",
      placeholder: t("placeholder-1"),
      type: "text",
    },
    {
      label: t(getKeyFromText("interest rate")),
      name: "interestRate",
      placeholder: "",
      type: "number",
    },
    {
      label: t(getKeyFromText("fixed interest rate")),
      name: "fixedInterestRate",
      placeholder: "",
      type: "date",
    },
    {
      label: t(getKeyFromText("for what")),
      name: "forWhat",
      placeholder: "",
      type: "text",
    },
    {
      label: t(getKeyFromText("credit institution")),
      name: "creditInstitution",
      placeholder: "",
      type: "text",
    },
    {
      label: t(getKeyFromText("account Number")),
      name: "accountNumber",
      placeholder: "",
      type: "text",
    },
  ];
};

export const addDonationsInitialValues = {
  donatedThings: "",
  donationValue: "",
  donationFrom: "",
  dateOfValue: "",
};
export const donations = (t) => {
  return [
    {
      label: t("donation-table-heading-1"),
      name: "dateOfValue",
      placeholder: "",
      type: "date",
    },
    {
      label: t("donation-table-heading-2"),
      name: "donatedThings",
      placeholder: "",
      type: "text",
    },
    {
      label: t("donation-table-heading-3"),
      name: "donationValue",
      placeholder: "000 €",
      type: "format-number",
    },
    {
      label: t("donation-table-heading-4"),
      name: "donationFrom",
      placeholder: t("placeholder-1"),
      type: "text",
    },
  ];
};
export const shareHoldings = (t) => {
  return [
    {
      label: t("common-table-heading-7"),
      name: "companyName",
      placeholder: t("soi-heading-2"),
      type: "text",
    },
    {
      label: t("common-table-heading-6"),
      name: "nameOfOwner",
      placeholder: t("placeholder-1"),
      type: "text",
    },
    {
      label: t("common-table-heading-2"),
      name: "ownerShipPercentage",
      placeholder: "00%",
      type: "number",
    },
    {
      label: t("common-table-heading-8"),
      name: "value",
      placeholder: "000 € ",
      type: "format-number",
    },

    {
      label: t("common-table-heading-9"),
      name: "information",
      placeholder: t("placeholder-7"),
      type: "textarea",
    },
  ];
};
export const coShareHoldings = (t) => {
  return [
    {
      label: t("common-table-heading-7"),
      name: "companyName",
      placeholder: t("soi-heading-2"),
      type: "text",
    },
    {
      label: t("common-table-heading-6"),
      name: "nameOfOwner",
      placeholder: t("placeholder-1"),
      type: "text",
    },
    {
      label: t("common-table-heading-2"),
      name: "ownerShipPercentage",
      placeholder: "00%",
      type: "number",
    },
    {
      label: t("common-table-heading-4"),
      name: "value",
      placeholder: "00 € ",
      type: "format-number",
    },
    {
      label: t("common-table-heading-9"),
      name: "information",
      placeholder: t("placeholder-7"),
      type: "textarea",
    },
  ];
};
export const addShareHoldingsInitialValues = {
  companyName: "",
  nameOfOwner: "",
  ownerShipPercentage: "",
  value: "",
  information: "",
};

export const sonstigesList = () => {
  return [
    {
      label: t("common-table-heading-5"),
      name: "type",
      placeholder: t("ChooseType"),
      type: "select",
    },
    {
      label: t("common-table-heading-6"),
      name: "nameOfOwner",
      placeholder: t("placeholder-1"),
      type: "text",
    },
    {
      label: t("common-table-heading-2"),
      name: "ownerShipPercentage",
      placeholder: "00%",
      type: "number",
    },
    {
      label: t("common-table-heading-10"),
      name: "quantity",
      placeholder: "",
      type: "text",
    },
    {
      label: t("common-table-heading-4"),
      name: "value",
      placeholder: "€",
      type: "format-number",
    },
    {
      label: t("common-table-heading-9"),
      name: "information",
      placeholder: t("placeholder-7"),
      type: "textarea",
    },
  ];
};
export const sonstigesValues = {
  type: "",
  nameOfOwner: "",
  ownerShipPercentage: "",
  quantity: "",
  value: "",
  information: "",
};
